import { Link } from "react-router-dom";
import { ArrowLeft, Coins, ShieldCheck } from "lucide-react";
import JackpotTicker from "@/components/JackpotTicker";
import { useAudio, useTrack } from "@/context/GameFeel";

export function GameFrame({ title, subtitle, children, side }) {
  useTrack("play");
  return (
    <div className="p-4 lg:p-8">
      <Link to="/casino" data-testid="back-to-casino" className="inline-flex items-center gap-2 text-gray-400 hover:text-white transition-colors duration-200 mb-4">
        <ArrowLeft className="w-4 h-4" /> Back to Casino
      </Link>
      <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-3 mb-6">
        <div>
          <h1 className="font-display text-3xl sm:text-4xl font-black">{title}</h1>
          <p className="text-gray-400">{subtitle}</p>
        </div>
        <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-amber-500/10 border border-amber-500/30 text-amber-300 text-xs font-semibold">
          <ShieldCheck className="w-3.5 h-3.5" /> Free coins · Just for fun
        </span>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">{children}</div>
        <div className="space-y-4"><JackpotTicker compact />{side}</div>
      </div>
    </div>
  );
}

export function BetControls({ bet, setBet, coins, disabled, onPlay, playLabel = "Play", testid = "play" }) {
  const { sfx } = useAudio();
  const quick = [-100, +100, "1/2", "2x", "max"];
  const apply = (q) => {
    sfx("tap");
    if (q === "1/2") setBet(Math.max(10, Math.floor(bet / 2)));
    else if (q === "2x") setBet(Math.min(coins || bet * 2, bet * 2));
    else if (q === "max") setBet(Math.min(coins, 100000));
    else setBet(Math.max(10, bet + q));
  };
  return (
    <div className="glass rounded-2xl p-5 border border-white/10">
      <label className="text-sm text-gray-400 mb-2 block">Coins to play</label>
      <div className="flex items-center gap-2 mb-3">
        <Coins className="w-5 h-5 text-amber-400" />
        <input data-testid="bet-input" type="number" min={10} value={bet}
          onChange={(e) => setBet(Math.max(10, parseInt(e.target.value) || 0))}
          className="w-full bg-black/40 border border-white/10 rounded-xl px-3 py-2.5 font-mono focus:border-amber-500 outline-none transition-colors duration-200" />
      </div>
      <div className="flex flex-wrap gap-2 mb-4">
        {quick.map((q) => (
          <button key={q} onClick={() => apply(q)} className="px-3 py-1.5 rounded-lg bg-white/5 border border-white/10 text-xs hover:bg-white/10 transition-colors duration-200">
            {typeof q === "number" ? (q > 0 ? `+${q}` : q) : q}
          </button>
        ))}
      </div>
      <button data-testid={`${testid}-button`} onClick={() => { sfx("tap"); onPlay(); }} disabled={disabled}
        className="w-full py-3.5 rounded-xl bg-gradient-to-r from-amber-500 to-purple-600 font-bold text-lg hover:opacity-90 transition-opacity duration-200 disabled:opacity-40">
        {playLabel}
      </button>
    </div>
  );
}
